import { useTranslation } from "react-i18next";
import { Conversations } from "@/partner/features/assistantConversations";
import { Meta } from "@/shared/components";

export function AudienceConversationsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("conversations.pageTitle")} pageType="Partner" />
      <Conversations />
    </>
  );
}
